import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientVaccine, PatientVaccineControllerApi } from "../../services";
import {
  DGT_Pagination,
  Page,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
} from "../../utils/utils";

interface Props {
  patientUuid: string;
  pagination: DGT_Pagination;
  searchString?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

interface VaccineListResponse {
  content: PatientVaccine[];
  page: Page;
}

export const usePatientPortalVaccineListHealthRecord = ({
  patientUuid,
  pagination,
  searchString,
  xTENANTID,
  enabled = true,
}: Props) => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  return useQuery({
    queryKey: [
      "patient-portal-vaccine-list",
      patientUuid,
      pageIndex,
      pageSize,
      searchString,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled && !!patientUuid,
    queryFn: async () =>
      await new PatientVaccineControllerApi(getConfigObject())
        .getPatientPortalVaccines(
          patientUuid,
          pageIndex,
          pageSize,
          xTENANTID
        )
        .then((res) => (res?.data?.data ?? res?.data) as VaccineListResponse),
  });
};
